module.exports = __webpack_public_path__ + "img/online.a11500fc.jpg";